module.exports = __webpack_public_path__ + "img/5.987a3c96.jpg";